const VISAS = [
  {
    href: "/visa/canada-visit-visa",
    image: "https://public.readdy.ai/ai/img_res/7a51606a8ca3cd96cf2f1fc6928bb835.jpg",
    title: "Canada Visit Visa",
    description: "From the Rockies to Niagara, Canada offers unmatched natural wonder. Let us handle your visit visa so your adventure starts without the paperwork stress.",
    price: "60,000",
  },
  {
    href: "/visa/spain-visit-visa",
    image: "https://readdy.ai/api/search-image?query=Spain%20Barcelona%20Sagrada%20Familia%20architecture%20colorful%20vibrant%20culture%20sunny%20Mediterranean%20travel%20destination%20European%20city%20historic%20warm%20summer%20coastal%20beauty&width=400&height=240&seq=home-visa-spain-001&orientation=landscape",
    title: "Spain Visit Visa",
    description: "Flamenco, tapas, and sun-soaked coastlines await. Spain is a traveller's paradise — we make sure your visa application is sorted before you even pack.",
    price: "60,000",
  },
  {
    href: "/visa/united-kingdom-visit-visa",
    image: "https://readdy.ai/api/search-image?query=United%20Kingdom%20London%20Big%20Ben%20Tower%20Bridge%20Thames%20River%20iconic%20landmark%20skyline%20classic%20British%20architecture%20red%20telephone%20box%20travel%20destination%20golden%20hour&width=400&height=240&seq=home-visa-uk-001&orientation=landscape",
    title: "United Kingdom Visit Visa",
    description: "Walk the streets of London, tour the Scottish Highlands, and soak in centuries of history. We guide you through the UK visa process step by step.",
    price: "60,000",
  },
  {
    href: "/visa/united-states-visit-visa",
    image: "https://readdy.ai/api/search-image?query=United%20States%20New%20York%20Manhattan%20skyline%20Statue%20of%20Liberty%20Hudson%20River%20aerial%20view%20skyscrapers%20modern%20cityscape%20stunning%20travel%20destination%20iconic%20American%20landmark&width=400&height=240&seq=home-visa-usa-001&orientation=landscape",
    title: "United States Visit Visa",
    description: "New York's skyline, the Grand Canyon, and Hollywood Hills — the US has it all. Our experts simplify the B1/B2 visa process for Pakistani applicants.",
    price: "50,000",
  },
  {
    href: "/visa/azerbaijan",
    image: "https://readdy.ai/api/search-image?query=Azerbaijan%20Baku%20Flame%20Towers%20old%20city%20Icheri%20Sheher%20Caspian%20Sea%20view%20night%20lights%20travel%20destination%20blend%20old%20modern%20architecture%20Eastern%20Europe%20Caucasus&width=400&height=240&seq=home-visa-azerbaijan-001&orientation=landscape",
    title: "Azerbaijan e-Visa",
    description: "Discover the crossroads of Europe and Asia. Azerbaijan's e-Visa is quick to obtain, and flightfare.pk walks Pakistani travellers through every step.",
    price: "12,500",
  },
  {
    href: "/visa/thailand",
    image: "https://readdy.ai/api/search-image?query=Thailand%20Bangkok%20Wat%20Arun%20temple%20golden%20pagoda%20Chao%20Phraya%20river%20sunset%20tropical%20travel%20destination%20vibrant%20colourful%20Southeast%20Asia%20beautiful%20spiritual%20architecture&width=400&height=240&seq=home-visa-thailand-001&orientation=landscape",
    title: "Thailand Tourist Visa",
    description: "Beaches, temples, street food, and vibrant nightlife — Thailand delivers it all. We handle your tourist visa so you can focus on planning the fun parts.",
    price: "17,500",
  },
  {
    href: "/visa/singapore",
    image: "https://readdy.ai/api/search-image?query=Singapore%20Marina%20Bay%20Sands%20Gardens%20by%20the%20Bay%20futuristic%20skyline%20night%20lights%20reflection%20water%20luxury%20modern%20Southeast%20Asia%20clean%20vibrant%20travel%20destination&width=400&height=240&seq=home-visa-singapore-001&orientation=landscape",
    title: "Singapore Tourist Visa",
    description: "A gleaming city-state packed with food, culture, and world-class attractions. Apply with scanned documents only — no original passport submission needed.",
    price: "18,500",
  },
  {
    href: "/visa/malaysia",
    image: "https://readdy.ai/api/search-image?query=Malaysia%20Kuala%20Lumpur%20Petronas%20Twin%20Towers%20skyline%20tropical%20lush%20green%20landscape%20travel%20destination%20Southeast%20Asia%20vibrant%20colorful%20culture%20beautiful%20city%20night%20lights&width=400&height=240&seq=home-visa-malaysia-001&orientation=landscape",
    title: "Malaysia Tourist Visa",
    description: "Kuala Lumpur towers, Langkawi beaches, and Borneo rainforests — Malaysia is endlessly diverse. Find out everything you need to plan your Malaysian escape.",
    price: "14,500",
  },
];

export default function VisaSection() {
  return (
    <section className="py-12 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-6">
          <h2 className="text-2xl font-bold text-gray-900">Visa Services</h2>
          <a
            href="/visa"
            className="inline-flex items-center gap-1 text-sm text-green-600 font-medium mt-1 cursor-pointer hover:underline"
          >
            View All
            <i className="ri-arrow-right-circle-line text-base"></i>
          </a>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-5">
          {VISAS.map(visa => (
            <a
              key={visa.href}
              href={visa.href}
              className="block rounded-lg overflow-hidden border border-gray-200 cursor-pointer hover:border-gray-300 transition-all group"
            >
              <div className="w-full h-44">
                <img
                  src={visa.image}
                  alt={visa.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="p-3">
                <p className="text-sm font-bold text-gray-900 mb-1">{visa.title}</p>
                <p className="text-xs text-gray-500 leading-relaxed mb-2 line-clamp-2">{visa.description}</p>
                <p className="text-sm font-semibold text-green-600">
                  PKR <span>{visa.price}</span>
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
